import { FaCheckCircle } from "react-icons/fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import { useParams } from "react-router-dom";

export default function InternalTransaction({ walletId, type }) {
  let paraId = useParams();
  const [datain, setDatain] = useState([]);
  const convertTimestampToDate = (timeStamp) => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian,
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };

  useEffect(() => {}, [walletId]);

  useEffect(() => {
    {
      type == "modal"
        ? connection("superadminapi/get_wallet_report", {
            wallet_id: walletId,
          }).then((data) => {
            setDatain(data.data);
            console.log("datainn:", data.data);
          })
        : connection("superadminapi/get_wallet_report", {
            wallet_id: "1",
          }).then((data) => {
            setDatain(data.data);
          });
    }
  }, [walletId]);
  console.log("val.to");
  return (
    <div
      className="tab-pane fade show active div-Shadow"
      id="Tab1"
      role="tabpanel"
      aria-labelledby="pills-home-tab"
    >
      {datain.length > 0 ? (
        <>
          {datain?.map((value, index) => {
            return (
              <div
                key={index}
                className="d-flex flex-row px-3 my-3 mx-1"
                style={{
                  border: "2px solid #A7A9D6",
                  borderRadius: "10px",
                  // width: "48%",
                }}
              >
                <FaCheckCircle
                  className="fs-3 me-2"
                  style={{ color: "#303481", marginTop: "13px" }}
                />
                <div className="d-flex flex-column  justify-content-around w-100">
                  <div className="d-flex flex-column justify-content-between flex-wrap ">
                    <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                      <div>
                        {value.from_wallet_id == "1"
                          ? value.to && (
                              <h5>
                                از کیف پول سبدی به کیف پول
                                {value.to[0].fullname} در تاریخ
                                {convertTimestampToDate(value.mtm)} انتقال داده
                                شد
                              </h5>
                            )
                          : value.from && (
                              <h5>
                                از کیف پول {value.from[0].fullname} به کیف پول{" "}
                                {""}
                                سبدی در تاریخ
                                {convertTimestampToDate(value.mtm)} انتقال داده
                                شد
                              </h5>
                            )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        "تراکنشی وجود ندارد."
      )}
    </div>
  );
}
